import React, {useEffect} from "react";
import { Route } from "react-router-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import {adminRoutes, studentRoutes, unauthedRoutes} from "./routes";
import withTracker from "./withTracker";
import './App.scss';

import "bootstrap/dist/css/bootstrap.min.css";
import "./dashboard-styles/shards-dashboards.1.1.0.min.css";
import {formatExpirationDate, isUserExpired, userIsAdmin} from "./helpers/helper-functions";
import {useSelectUserProperty} from "./firebase-listeners/firestore-user";
import {signOut} from "./actions/auth";

const initialState = {
    counter: 0
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INCREASE_COUNTER':
            return { counter: state.counter + 1 }
        case 'DECREASE_COUNTER':
            return { counter: state.counter - 1 }
        default:
            return state
    }
}

const store = createStore(reducer)

function Guard(props) {
    const uid = useSelectUserProperty('uid');
    const firstname = useSelectUserProperty('firstname');
    const licenseExpirationDate = useSelectUserProperty('licenseExpirationDate');

    useEffect(() => {
        if (!uid) {
            return
        }
        if (userIsAdmin(uid)) {
            return
        }
        const expired = isUserExpired({licenseExpirationDate})
        if (expired) {
            alert(`Please renew your license! Your license expired on ${formatExpirationDate(licenseExpirationDate)}!`);
            signOut().then(() => props.history.push(`/student/signin`))
        }
        if (props.admin) {
            const queryParams = firstname ? `?firstname=${firstname}` : '';
            props.history.push(`/student/home${queryParams}`);
        }
    }, [firstname, licenseExpirationDate, props.admin, props.history, uid]);
    return <>{props.children}</>;
}

function App() {
    document.title="Reqmaster";

    return (
        <Provider store={store}>
                    {/* basename={process.env.REACT_APP_BASENAME || ""} */}
                    {/* {document.addEventListener('contextmenu', event => event.preventDefault())}  */}
                <div style={{ backgroundColor: 'white', width: window.innerWidth, height: window.innerHeight }}>
                    {unauthedRoutes.map((route, index) => {
                        return (
                            <Route
                                key={index}
                                path={route.path}
                                exact={route.exact}
                                component={withTracker(props => {
                                    return (
                                        <>
                                            <route.component {...props} />
                                        </>
                                    );
                                })}
                            />
                        );
                    })}
                    {adminRoutes.map((route, index) => {
                        return (
                            <Route
                                key={index}
                                path={route.path}
                                exact={route.exact}
                                component={withTracker(props => {
                                    return (
                                        <>
                                            <Guard admin={true} history={props.history}><route.component {...props} /></Guard>
                                        </>
                                    );
                                })}
                            />
                        );
                    })}
                    {studentRoutes.map((route, index) => {
                        return (
                            <Route
                                key={index}
                                path={route.path}
                                exact={route.exact}
                                component={withTracker(props => {
                                    return (
                                        <>
                                            <Guard admin={false} history={props.history}><route.component {...props} /></Guard>
                                        </>
                                    );
                                })}
                            />
                        );
                    })}
                </div>
        </Provider>
    )

}

export default App

